import React from "react";
import { Link, NavLink } from "react-router-dom";
import { RWebShare } from "react-web-share";
import { trackEvent } from "../../utils/tracking";

const Header = () => {
  return (
    <header className="cm-header">
      <div className="header-top bg-blue">
        <div className="container">
          <div className="row">
            <div className="col-xl-10">
              <div className="d-block d-md-flex justify-content-center justify-content-xl-start">
                <div className="block text-gray mr-35">
                  <span className="icon text-primary fas fa-phone-alt mr-15" />
                  <a
                    href="tel:+12159393933"
                    style={{ color: "#dddddd" }}
                    onClick={() => trackEvent.phoneCall({ source: "header" })}
                  >
                    +1(215) 939-3933
                  </a>
                </div>
                <div className="block text-gray mr-35">
                  <span className="icon text-primary fas fa-envelope mr-15" />
                  <a
                    href="mailto:icellstation1@gmail.com"
                    style={{ color: "#dddddd" }}
                  >
                    icellstation1@gmail.com
                  </a>
                </div>
                <Link to={"/store-location"}>
                  <div className="block text-gray">
                    <span className="icon text-primary fas fa-home mr-15" />
                    2500 W Moreland Rd,Willow Grove, PA
                  </div>
                </Link>
              </div>
            </div>
            <div className="col-xl-2 d-none d-xl-block">
              <div className="block d-flex justify-content-end">
                <a
                  href="https://www.facebook.com/icellstation/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary initiate-scripts"
                  aria-label="Facebook"
                >
                  <span className="icon fab fa-facebook-f border-right-0" />
                </a>
                <a
                  href="https://www.tiktok.com/@icellstation?lang=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary initiate-scripts"
                  aria-label="TikTok"
                >
                  <span className="icon fab fa-tiktok border-right-0" />
                </a>
                <a
                  href="https://www.youtube.com/channel/UC_ju-JULprEqMmO3Wlj7DyA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary initiate-scripts"
                  aria-label="YouTube"
                >
                  <span className="icon fab fa-youtube" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="header">
        <div className="container h-100">
          <div className="row h-100 align-content-center">
            <div className="col-md-12">
              <nav className="navbar navbar-expand-lg navbar-light px-0">
                <Link className="navbar-brand initiate-scripts" to={"/"}>
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/logo.jpg"}
                    alt="logo" loading="lazy"
                  />
                </Link>
                <button
                  className="navbar-toggler border-0 p-0"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navLinks"
                  aria-controls="navLinks"
                  aria-expanded="false"
                >
                  <span className="navbar-toggler-icon" />
                </button>

                <div className="collapse navbar-collapse" id="navLinks">
                  <ul className="navbar-nav ml-auto align-items-center">
                    <li className="nav-item">
                      <NavLink
                        className={({ isActive }) =>
                          `nav-link initiate-scripts${isActive ? " active" : ""}`
                        }
                        to="/"
                        end
                      >
                        Home
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className={({ isActive }) =>
                          `nav-link initiate-scripts${isActive ? " active" : ""}`
                        }
                        to="/services"
                      >
                        Services
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className={({ isActive }) =>
                          `nav-link initiate-scripts${isActive ? " active" : ""}`
                        }
                        to="/blog"
                      >
                        Blog
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className={({ isActive }) =>
                          `nav-link initiate-scripts${isActive ? " active" : ""}`
                        }
                        to="/shop"
                      >
                        Shop
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className={({ isActive }) =>
                          `nav-link initiate-scripts${isActive ? " active" : ""}`
                        }
                        to="/about-us"
                      >
                        About Us
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className={({ isActive }) =>
                          `nav-link initiate-scripts${isActive ? " active" : ""}`
                        }
                        to="/contact-us"
                      >
                        Contact Us
                      </NavLink>
                    </li>
                    <div className="block d-flex mt-3 mt-lg-0">
                      <RWebShare
                        data={{
                          text: "Hello Everyone, here's Our website. Feel free to reach out if you need any assistance, and I'd appreciate it if you could share it with your network. Thank you!",
                          url: "https://www.icellstation.com/",
                          title: "From Admin",
                        }}
                        onClick={() => console.log("shared successfully!")}
                      >
                        <span
                          className="icon fas fa-share-alt text-dark"
                          role="button"
                        />
                      </RWebShare>
                      <Link
                        className="icon pr-0 pt-0 pb-0 text-dark initiate-scripts"
                        to={"/shop"}
                      >
                        <span className="fas fa-shopping-bag" />
                      </Link>
                    </div>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

// Will do this update later to make the logo to the right and the rest to the left:

// import React, { useState } from "react";
// import { NavLink, Link } from "react-router-dom";
// import { RWebShare } from "react-web-share";

// const navLinkClass = ({ isActive }) =>
//   `nav-link initiate-scripts ${isActive ? "active" : ""}`;

// const navLinkDropdownClass = ({ isActive }) =>
//   `nav-link dropdown-toggle initiate-scripts ${isActive ? "active" : ""}`;

// const Header = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const toggle = () => setIsOpen((o) => !o);
//   const close = () => setIsOpen(false);

//   return (
//     <header className="cm-header">
//       <div className="header-top bg-blue">
//         <div className="container">
//           <div className="row">
//             <div className="col-xl-10">
//               <div className="d-block d-md-flex justify-content-center justify-content-xl-start">
//                 <div className="block text-gray mr-35">
//                   <span className="icon text-primary fas fa-phone-alt mr-15" />
//                   <a href="tel:+12159393933" style={{ color: "#dddddd" }}>
//                     +1 (215) 939-3933
//                   </a>
//                 </div>
//                 <div className="block text-gray mr-35">
//                   <span className="icon text-primary fas fa-envelope mr-15" />
//                   <a
//                     href="mailto:icellstation1@gmail.com"
//                     style={{ color: "#dddddd" }}
//                   >
//                     icellstation1@gmail.com
//                   </a>
//                 </div>
//                 <Link
//                   to="/store-location"
//                   className="text-reset initiate-scripts"
//                 >
//                   <div className="block text-gray">
//                     <span className="icon text-primary fas fa-home mr-15" />
//                     2500 W Moreland Rd, Willow Grove, PA
//                   </div>
//                 </Link>
//               </div>
//             </div>

//             <div className="col-xl-2 d-none d-xl-block">
//               <div className="block d-flex justify-content-end">
//                 <a
//                   href="https://www.facebook.com/icellstation/"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-primary initiate-scripts"
//                   aria-label="Facebook"
//                 >
//                   <span className="icon fab fa-facebook-f border-right-0" />
//                 </a>
//                 <a
//                   href="https://www.tiktok.com/@icellstation?lang=en"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-primary initiate-scripts"
//                   aria-label="TikTok"
//                 >
//                   <span className="icon fab fa-tiktok border-right-0" />
//                 </a>
//                 <a
//                   href="https://www.youtube.com/channel/UC_ju-JULprEqMmO3Wlj7DyA"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-primary initiate-scripts"
//                   aria-label="YouTube"
//                 >
//                   <span className="icon fab fa-youtube" />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <nav className="navbar navbar-expand-lg navbar-light px-0">
//         <NavLink
//           className="navbar-brand initiate-scripts"
//           to="/"
//           onClick={close}
//         >
//           <img
//             src={process.env.PUBLIC_URL + "/assets/images/logo.jpg"}
//             alt="Cell Station logo"
// loading="lazy"           />
//         </NavLink>

//         <button
//           className="navbar-toggler border-0 p-0"
//           type="button"
//           aria-controls="navLinks"
//           aria-expanded={isOpen}
//           aria-label="Toggle navigation"
//           onClick={toggle}
//         >
//           <span className="navbar-toggler-icon" />
//         </button>

//         <div
//           className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
//           id="navLinks"
//         >
//           <ul className="navbar-nav ml-auto align-items-center">
//             <li className="nav-item dropdown">
//               <NavLink
//                 to="/"
//                 end
//                 className={navLinkDropdownClass}
//                 role="button"
//                 onClick={close}
//               >
//                 Home <span className="text-primary"></span>
//               </NavLink>
//             </li>

//             <li className="nav-item">
//               <NavLink to="/services" className={navLinkClass} onClick={close}>
//                 Services
//               </NavLink>
//             </li>

//             <li className="nav-item dropdown">
//               <NavLink
//                 to="/blog"
//                 className={navLinkDropdownClass}
//                 role="button"
//                 onClick={close}
//               >
//                 Blog <span className="text-primary"></span>
//               </NavLink>
//             </li>

//             <li className="nav-item dropdown">
//               <NavLink
//                 to="/shop"
//                 className={navLinkDropdownClass}
//                 role="button"
//                 onClick={close}
//               >
//                 Shop
//               </NavLink>
//             </li>

//             <li className="nav-item">
//               <NavLink to="/about-us" className={navLinkClass} onClick={close}>
//                 About Us
//               </NavLink>
//             </li>

//             <li className="nav-item">
//               <NavLink
//                 to="/contact-us"
//                 className={navLinkClass}
//                 onClick={close}
//               >
//                 Contact Us
//               </NavLink>
//             </li>

//             <div className="block d-flex mt-3 mt-lg-0">
//               <RWebShare
//                 data={{
//                   text: "Hello Everyone, here’s Our website. Feel free to reach out if you need any assistance, and I’d appreciate it if you could share it with your network. Thank you!",
//                   url: "https://www.icellstation.com/",
//                   title: "From Admin",
//                 }}
//                 onClick={() => console.log("shared successfully!")}
//               >
//                 <span
//                   className="icon fas fa-share-alt text-dark"
//                   role="button"
//                 />
//               </RWebShare>

//               <NavLink
//                 to="/shop"
//                 className={({ isActive }) =>
//                   `icon pr-0 pt-0 pb-0 text-dark initiate-scripts ${
//                     isActive ? "active" : ""
//                   }`
//                 }
//                 aria-label="Shopping bag"
//                 onClick={close}
//               >
//                 <span className="fas fa-shopping-bag" />
//               </NavLink>
//             </div>
//           </ul>
//         </div>
//       </nav>
//     </header>
//   );
// };

// export default Header;
